import React from 'react';

import { Box, Icon, IconButton, Paper, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { UseDrawerContext } from '../context';


interface ILayoutBaseProps {
    title: string;
    tollBar?: React.ReactNode;
    children: React.ReactNode;
    overflowUser?: string;
}

export const LayoutBase:React.FC<ILayoutBaseProps> = ({ children, title: titulo, tollBar: barraDeFerramentas, overflowUser = 'auto' }) => {

    const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

    const theme = useTheme();

    const { toggleDrawerOpen } = UseDrawerContext();

    return (
        <Box height={'100%'} display={'flex'} flexDirection={'column'} gap={1}>

            <Box padding={1} display={'flex'} alignItems={'center'} gap={1} height={theme.spacing(lgDown? 6 : lgDown? 8 : 12)}>
                {lgDown && (
                <IconButton onClick={toggleDrawerOpen}>
                    <Icon color='secondary'>menu</Icon>
                </IconButton>)}

                <Typography
                 variant={lgUp? 'h3' : smDown? 'h6' : 'h4'}
                 overflow={'hidden'}
                 whiteSpace={'nowrap'}
                 textOverflow={'ellipsis'}
                 color={'white'}
                >
                    {titulo}
                </Typography>
            </Box>

            {barraDeFerramentas && (
            <Box borderRadius={10}>
                {barraDeFerramentas}
            </Box>)}

            <Box 
             overflow={overflowUser}
             component={Paper}
             flex={1}
             borderRadius={3}
             marginX={1}
             padding={1}
             paddingLeft={1}
            >
                {children}
            </Box>

        </Box>
    );
};